/**
 * Icones para organizar e visualizar botões SOMENTE dentro do CaptaZap.
 * A Meta Cloud API não oferece personalização de ícones em botões oficiais.
 */
import {
  CheckCircle2, CalendarDays, Clock3, MessageCircle, Phone,
  ExternalLink, Gift, CreditCard, MapPin, XCircle, ArrowRight,
  Copy, HelpCircle, Heart, Star, MessageSquareText
} from "lucide-react";

export const META_TEMPLATE_BUTTON_ICONS = Object.freeze([
  {id:"auto",label:"Padrão do tipo",Icon:null},
  {id:"check-circle",label:"Confirmar",Icon:CheckCircle2},
  {id:"calendar-days",label:"Agenda",Icon:CalendarDays},
  {id:"clock-3",label:"Horário",Icon:Clock3},
  {id:"message-circle",label:"Conversa",Icon:MessageCircle},
  {id:"phone",label:"Telefone",Icon:Phone},
  {id:"external-link",label:"Site",Icon:ExternalLink},
  {id:"gift",label:"Presente",Icon:Gift},
  {id:"credit-card",label:"Pagamento",Icon:CreditCard},
  {id:"map-pin",label:"Localização",Icon:MapPin},
  {id:"x-circle",label:"Cancelar",Icon:XCircle},
  {id:"arrow-right",label:"Continuar",Icon:ArrowRight},
  {id:"copy",label:"Copiar",Icon:Copy},
  {id:"help-circle",label:"Dúvida",Icon:HelpCircle},
  {id:"heart",label:"Coração",Icon:Heart},
  {id:"star",label:"Favorito",Icon:Star},
]);

export function MetaTemplateButtonIcon({iconId="auto", type="QUICK_REPLY", size=16}) {
  const selected = META_TEMPLATE_BUTTON_ICONS.find(x=>x.id===iconId);
  const DefaultIcon = type==="URL"?ExternalLink:type==="PHONE_NUMBER"?Phone:type==="COPY_CODE"?Copy:MessageSquareText;
  const Icon=selected?.Icon||DefaultIcon;
  return <Icon size={size} aria-hidden="true"/>;
}
